module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: 'icon ico-' + _vm.name,
    attrs: {
      "viewBox": _vm.viewBox || '0 0 100 100'
    }
  }, [(_vm.titleTag) ? _c('title', [_vm._v(_vm._s(_vm.titleTag))]) : _vm._e(), _vm._v(" "), _c('use', {
    attrs: {
      "xlink:href": _vm.reference
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-339db8d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Icon.vue
// module id = 536
// module chunks = 225